import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto bg-background-50 rounded-3xl border border-background-200/70 p-8 md:p-12 text-center">
          <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-accent-100/80 text-accent-600 text-2xl mb-5">
            <i className="ri-shield-check-line"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Centrum Bezpieczeństwa Kakobuy
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-6">
            Dowiedz się, jak bezpiecznie kupować przez Kakobuy. Poznaj zasady ochrony kupujących,
            sprawdź, jak działają zdjęcia QC, i naucz się unikać najczęstszych błędów.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/artykul/czy-kakobuy-jest-bezpieczny"
              className="w-full sm:w-auto px-6 py-3 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shield-check-line mr-2"></i>
              Sprawdź bezpieczeństwo Kakobuy
            </Link>
            <a
              href="#faq"
              className="w-full sm:w-auto px-6 py-3 bg-background-100 text-foreground-700 font-semibold text-sm rounded-full hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-question-line mr-2"></i>
              Najczęstsze pytania
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}